export default {
  number: 0,
  search: {},
  song: {}
}



// WEBPACK FOOTER //
// ./src/store/state/index.js